import { useMemo } from "react";
import { InfoCampaignCardsType } from "./infoCampaignCardsTypes.ts";
import { useAppSelector } from "../../../../stores/hooks/hooks.ts";
import { RevCard } from "@revmatics/catalyst";
import { fullFormatNumbers } from "../../../../helpers/functions/formatNumber.ts";

export const InfoCampaignCards = () => {
  const campaignsInfo = useAppSelector(
    (state) => state.campaigns.campaignsInfoData,
  );
  const data: InfoCampaignCardsType | null = useMemo(() => {
    const budget = Number(campaignsInfo?.total_budget);
    return campaignsInfo
      ? [
          {
            title: "Total Managed Budget",
            value: `$${fullFormatNumbers({ value: budget, shortenValue: 1e9 })}`,
          },
          { title: "Campaigns On Track", value: `${campaignsInfo.on_track}` },
          { title: "Campaigns Off Track", value: `${campaignsInfo.off_track}` },
          {
            title: "Campaigns Work in Progress",
            value: `${campaignsInfo.in_progress}`,
          },
        ]
      : null;
  }, [campaignsInfo]);

  if (data) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
        {data.map((elem, index) => (
          <RevCard key={`info-card-campaign-${index}-${elem.value}`}>
            <p className="typography-body-sm text-monochrome-500 mb-2">
              {elem.title}
            </p>
            <h4>{elem.value}</h4>
          </RevCard>
        ))}
      </div>
    );
  }
  return null;
};
